import axios from 'axios'
import router from '../../router'
export default {
  namespaced: true,

  state: {
    authenticated: false,
    user:null
  },

  getters: {
    authenticated (state) {
      return state.authenticated
  },

    user (state) {
      return state.user
    },
  },

  mutations: {
    SET_AUTHENTICATED (state, value) {
      state.authenticated = value
    },
    SET_USER (state, value) {
      state.user = value
    },
  },

  actions: {
    async signIn ({ dispatch, state }, credentials) {
        try {
          const { data: { status, messages } } = await axios.post('api/login', credentials)

          if (status) {
            await axios.get('/sanctum/csrf-cookie')
            await dispatch('me')

            if (state.authenticated){
              router.push('/home')
            }
          }

          return { status, messages }

        } catch (error) {
          console.warn('Failed fetch [store/auth/signIn]', error);
        }
      },

      async signOut ({ dispatch }) {
        try {
          await axios.post('api/logout')
          sessionStorage.removeItem('XSRF-TOKEN')
          router.push('/auth')
          await dispatch('me')
        } catch (error) {
          console.warn('Failed fetch [store/auth/signOut]', error);
        }
      },

      async me ({ commit }) {
        try {
          const response = await axios.get('api/user');

          if (response.data.id){
            commit('SET_AUTHENTICATED', true)
            commit('SET_USER', response.data)
          } else {
            commit('SET_AUTHENTICATED', false)
            commit('SET_USER', null)
          }

        } catch (error) {
          console.warn('Failed fetch [store/auth/me]', error);
          commit('SET_AUTHENTICATED', false)
          commit('SET_USER', null)
        }
      },

      async auth () {
        try {
          const { data, status } = await axios.get('api/auth');

          if (status === 200 && data) {
            const regex = /<meta\s+name=["']csrf-token["']\s+content=["']([^"']+)["']/i;
            const match = data.match(regex);

            if (match) {
              axios.defaults.headers['X-CSRF-TOKEN'] = match[1];
            }
          }
        } catch (error) {
          console.warn('Failed fetch [store/auth/auth]', error);
        }
      },
  }
}
